import React from "react";
import "./Style/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="no-copy-text">
              <section
                className="py-5"
                style={{ background: "black" }}
              >
                <div className="container">
                  <h1 className="aboutheading">Privacy Policy</h1>
                  <div className="privacypolicycontent">
                    <section>
                      <h2>1. Introduction</h2>
                      <p>Welcome to <strong>DesiKothi</strong> ("we," "our," or "us").</p>
                      <p>
                        This Privacy Policy explains how we collect, use, and protect your
                        information when you use the DesiKothi mobile application (the
                        <em>"App"</em>).
                      </p>
                      <p>
                        DesiKothi is a <strong>business management platform</strong> that enables
                        salespersons and vendors to create, manage, and track shop orders and sales
                        transactions.
                      </p>
                      <p>By using our App, you agree to this Privacy Policy.</p>
                    </section>

                    {/* 2. Information We Collect */}
                    <section>
                      <h2>2. Information We Collect</h2>
                      <p>We collect the following types of information to provide our services:</p>

                      {/* 2.a. Personal & Business Information */}
                      <div className="sub-section">
                        <h3>a. Personal &amp; Business Information</h3>
                        <ul>
                          <li>
                            Name, phone number, email address, and business details (shop name,
                            vendor name, etc.).
                          </li>
                          <li>
                            Login credentials and profile information for salespersons or vendors.
                          </li>
                        </ul>
                      </div>

                      {/* 2.b. Order & Transaction Data */}
                      <div className="sub-section">
                        <h3>b. Order &amp; Transaction Data</h3>
                        <ul>
                          <li>Order details (product, quantity, pricing, and customer info).</li>
                          <li>Sales records, invoices, and payment status.</li>
                          <li>Data entered by salespersons or vendors during business operations.</li>
                        </ul>
                      </div>

                      {/* 2.c. Device & Usage Information */}
                      <div className="sub-section">
                        <h3>c. Device &amp; Usage Information</h3>
                        <ul>
                          <li>Device type, operating system, app version, and IP address.</li>
                          <li>
                            App usage analytics (screen views, activity logs) to improve
                            performance.
                          </li>
                        </ul>
                      </div>

                      {/* 2.d. Location Data */}
                      <div className="sub-section">
                        <h3>d. Location Data (if applicable)</h3>
                        <ul>
                          <li>
                            If you enable location access, we may use it to verify sales activity or
                            delivery areas.
                          </li>
                          <li>
                            Location data is not shared with third parties and is used only within
                            the app’s functionality.
                          </li>
                        </ul>
                      </div>
                    </section>

                    {/* 3. How We Use Your Information */}
                    <section>
                      <h2>3. How We Use Your Information</h2>
                      <p>We use your information to:</p>
                      <ul>
                        <li>Allow vendors and salespersons to manage and track sales orders.</li>
                        <li>Process transactions and generate invoices or reports.</li>
                        <li>Maintain business records and manage account access.</li>
                        <li>Improve our App and provide technical support.</li>
                        <li>Communicate important updates, alerts, or policy changes.</li>
                        <li>Comply with legal and regulatory obligations.</li>
                      </ul>
                    </section>

                    {/* 4. Data Storage & Security */}
                    <section>
                      <h2>4. Data Storage &amp; Security</h2>
                      <ul>
                        <li>
                          We use <strong>secure servers</strong> and
                          <strong> encryption (HTTPS, SSL)</strong> to store and transmit data
                          safely.
                        </li>
                        <li>
                          We take reasonable steps to protect your data against unauthorized access,
                          modification, or deletion.
                        </li>
                        <li>
                          Your data remains private and is stored only for as long as necessary to
                          provide our services.
                        </li>
                      </ul>
                    </section>

                    {/* 5. Data Sharing */}
                    <section>
                      <h2>5. Data Sharing</h2>
                      <p>We do not sell, rent, or trade your personal information.</p>
                      <p>We may share limited data only:</p>
                      <ul>
                        <li>
                          With service providers or APIs that help us operate the app (under strict
                          confidentiality).
                          
                        </li>
                        <li>If required by law or a government authority.</li>
                        <li>
                          For example: cloud hosting, analytics, or payment processors (if
                          applicable).
                        </li>
                      </ul>
                    </section>

                    {/* 6. Your Rights */}
                    <section>
                      <h2>6. Your Rights</h2>
                      <p>You have the right to:</p>
                      <ul>
                        <li>Access or update your profile or business data.</li>
                        <li>Request deletion of your account and personal information.</li>
                        <li>
                          Withdraw consent to data collection (subject to legal or business
                          constraints).
                        </li>
                      </ul>
                        <p>
                          Contact us at{" "}
                          <a href="mailto:info@desikothiicecream.com.au">
                            info@desikothiicecream.com.au
                          </a>{" "}
                          for any data-related requests.
                        </p>
                    </section>

                    {/* 7. Third-Party Services */}
                    <section>
                      <h2>7. Third-Party Services</h2>
                      <p>
                        The App may include links or integrations with third-party tools (such as
                        analytics or payment systems).
                      </p>
                      <p>
                        Each third-party service has its own privacy policy, and we encourage you to
                        review them separately.
                      </p>
                    </section>

                    {/* 8. Children's Privacy */}
                    <section>
                      <h2>8. Children's Privacy</h2>
                      <p>
                        DesiKothi is intended for <strong>business use only</strong> and not for
                        individuals under <strong>18 years of age</strong>.
                      </p>
                      <p>We do not knowingly collect personal information from minors.</p>
                    </section>

                    {/* 9. Changes to This Policy */}
                    <section>
                      <h2>9. Changes to This Policy</h2>
                      <p>We may update this Privacy Policy from time to time.</p>
                      <p>
                        Any updates will be posted within the App, and the revised date will be
                        shown above.
                      </p>
                    </section>

                    {/* 10. Contact Us */}
                    <section>
                      <h2>10. Contact Us</h2>
                      <p>
                        If you have any questions about this Privacy Policy or your data, please
                        contact:
                      </p>
                      <div className="contact-info">
                        <p>
                          <strong>DesiKothi Support Team</strong>
                        </p>
                        <p>
                          Email:{" "}
                          <a href="mailto:info@desikothiicecream.com.au">
                            info@desikothiicecream.com.au
                          </a>
                        </p>
                        <p>
                          Website:{" "}
                          <a
                            href="https://www.desikothiicecream.com.au"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            www.desikothiicecream.com.au
                          </a>
                        </p>
                        <p>Address: U-3, 1-3 Kilmur Rd, Hoppers Crossing, Victoria 3029</p>
                      </div>
                    </section>

                  </div>
                </div>
              </section>
    </div>
  );
  
};


export default PrivacyPolicy;
